import { FC } from 'react';
import { Box } from '@mui/material';
import { toString } from 'lodash';
import { AsyncCellSkeleton } from 'components/ScalarSpreadsheet/components/AsyncCell';
import { TaskCell } from 'pages/Funds/components';
import { useTasksProgress } from './FirmSummaryAsyncCells.contexts';
import { TasksProgressCellProps } from './types';

/**
 * Process Management column cell. GET /api/firms/{firm}/requests-progress is the slowest request
 * on the page, so it no longer gates the grid: the cell subscribes to the response and swaps its
 * placeholder for the real task boxes once it lands.
 */
const TasksProgressCell: FC<TasksProgressCellProps> = ({
  cellKey,
  companyName,
  companySlug,
  fundName,
  onTaskClick,
}) => {
  const { isLoading, measurementDateName, tasksProgress } = useTasksProgress();

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center">
        <AsyncCellSkeleton width="2.5rem" />
      </Box>
    );
  }

  return (
    <TaskCell
      cellKey={cellKey}
      companyName={companyName}
      companySlug={companySlug}
      fundName={fundName}
      measurementDateName={toString(measurementDateName)}
      onTaskClick={onTaskClick}
      tasksProgress={tasksProgress}
    />
  );
};

export default TasksProgressCell;
